module.exports = __webpack_public_path__ + "static/media/globe_online_world_icon.de21dbaf.svg";